// extracted by mini-css-extract-plugin
export default {"root":"qoYs1","title":"kZhXj","text":"i0zQs"};